/**
 * Hakkımızda CMS içeriğini çekip i18n `about` namespace'ine birleştirir.
 * @param {{ enabled?: boolean }} [options]
 */

import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ENV } from '../../config/env'

export function useAboutCmsSync(options = {}) {
  const enabled = options.enabled !== false
  const { i18n } = useTranslation()

  useEffect(() => {
    if (!enabled) return
    const lang = (i18n.language || 'tr').split('-')[0]
    const base = ENV.API_BASE_URL.replace(/\/+$/, '')
    if (!base) return

    let cancelled = false

    ;(async () => {
      try {
        const r = await fetch(`${base}/public/about-content.php?lang=${encodeURIComponent(lang)}`)
        const body = await r.json()
        if (cancelled) return
        const c = body?.success ? body?.data?.content : null
        if (c && typeof c === 'object' && !Array.isArray(c) && Object.keys(c).length > 0) {
          i18n.addResourceBundle(lang, 'about', c, true, true)
        }
      } catch {
        /* sessiz */
      }
    })()

    return () => {
      cancelled = true
    }
  }, [i18n, i18n.language, enabled])
}
